<template>
  <el-dropdown @command="handleChangeLanguage">
    <el-button link>
      {{ currentLanguageLabel }}
    </el-button>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
        <el-dropdown-item command="ug">ئۇيغۇرچە</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAppStore } from '@/stores/app'

const { locale } = useI18n()
const appStore = useAppStore()

const languageLabels = {
  zh: '中文',
  ug: 'ئۇيغۇرچە',
  en: 'English',
}

const currentLanguageLabel = computed(() => languageLabels[locale.value] || '中文')

const handleChangeLanguage = (lang) => {
  locale.value = lang
  appStore.setLanguage(lang)
  
  // if (lang === 'ug') {
    // document.body.classList.add('uyghur-font')
  // } else {
  //   document.body.classList.remove('uyghur-font')
  // }
}
</script>

<style scoped lang="scss">
:deep(.el-dropdown-menu) {
  html.dark & {
    background-color: var(--bg-color-white, #2d3748);
    border-color: var(--border-color-light, #4a5568);
  }
  
  .el-dropdown-menu__item {
    html.dark & {
      color: var(--color-text-primary, #f7fafc);
      
      &:hover {
        background-color: var(--border-color-light, #4a5568);
        color: var(--el-color-primary, #409eff);
      }
      
      &.is-disabled {
        color: var(--color-text-placeholder, #718096);
      }
    }
  }
}

:deep(.el-button.is-link) {
  html.dark & {
    color: var(--color-text-primary, #f7fafc);
    
    &:hover {
      color: var(--el-color-primary, #409eff);
    }
  }
}

:deep(.el-select-dropdown) {
  html.dark & {
    background-color: var(--bg-color-white, #2d3748);
    border-color: var(--border-color-light, #4a5568);
  }
  
  .el-select-dropdown__item {
    html.dark & {
      color: var(--color-text-primary, #f7fafc);
      
      &.hover,
      &:hover {
        background-color: var(--border-color-light, #4a5568);
        color: var(--el-color-primary, #409eff);
      }
      
      &.is-disabled {
        color: var(--color-text-placeholder, #718096);
      }
    }
  }
}
</style>
